import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import images from 'Assets/Images'
import { MessageErrorInput } from 'Components/Message/Error/input'
import { useFormChildLogic } from '../index'

export const InputUnstyled = memo(props => {
  const {
    id,
    placeholder,
    disabled = false,
    name,
    meta = {},
    input = {},
    validator,
  } = props

  // Some old components are still using "value" prop
  const initValue = props.initValue || props.value

  const { updateForm, value, error } = useFormChildLogic({
    name,
    validator,
    initValue,
  })

  var onChange = props.onChange || input.onChange
  var onBlur = props.onBlur || input.onBlur
  const defaultValue =
    props.defaultValue !== undefined ? props.defaultValue : input.defaultValue

  const type = props.type || 'text'
  const className = `${
    props.className
  } ${type}-input-wrapper ${props.className || ''} ${
    hasError() ? 'has-error' : ''
  }`

  const handleChange = useCallback(
    e => {
      onChange && onChange(e)
      updateForm(e.target.value)
    },
    [validator, onChange],
  )

  return [
    <div key="input" className={className}>
      {renderLabel()}
      <input
        id={id}
        test-id={props['test-id']}
        name={name}
        disabled={disabled}
        defaultValue={defaultValue === undefined ? '' : defaultValue}
        placeholder={placeholder}
        type={type}
        onChange={handleChange}
        onBlur={onBlur}
        value={value || input.value}
      />
      {renderIcon()}
    </div>,
    renderError(error),
  ]

  /**
   * Render label
   * @returns JSX.Element | null
   */
  function renderLabel() {
    const { label, id } = props

    return label ? (
      <label className="label" htmlFor={id}>
        {label}
      </label>
    ) : null
  }

  /**
   * Render icon
   * @returns JSX.Element | null
   */
  function renderIcon() {
    const icon = props.icon
    let iconImage

    if (icon) {
      switch (icon) {
        case 'user':
          iconImage = images.userIcon
          break
        case 'password':
          iconImage = images.passwordIcon
          break
        case 'email':
          iconImage = images.emailIcon
          break
      }
    }

    return icon ? <img className="icon" src={iconImage} alt="icon" /> : null
  }

  /**
   * Input has error
   * @returns boolean
   */
  function hasError(error) {
    return props.error || (meta.touched && meta.error) || error
  }

  /**
   * Render field error
   * @returns JSX.Element | null
   */
  function renderError(error) {
    const inputError = meta.error || props.error || error

    return hasError(error) ? (
      <MessageErrorInput key="errorMessage" message={inputError} />
    ) : null
  }
})

InputUnstyled.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.oneOf(['user', 'password', 'email']),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  input: PropTypes.shape({
    onChange: PropTypes.func,
  }),
}



// WEBPACK FOOTER //
// ./src/Components/Form/Input/unstyled.js